'use client';
import * as z from 'zod/mini';
import { safeLocalStorageGetItem, safeLocalStorageSetItem } from '@//utils/safe-storage';

export const FilterHistoryItemSchema = z.object({
  id: z
    .string()
    .check(z.regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)),
  query: z.string(),
  label: z.string(),
  date: z.string().check(z.refine((val) => !Number.isNaN(Date.parse(val)), 'Invalid datetime')),
});

export type FilterHistoryItem = z.infer<typeof FilterHistoryItemSchema>;

export const FILTER_HISTORY_STORAGE_KEY = 'filterHistory';
export const FILTER_HISTORY_STORAGE_QUERY_KEY = [FILTER_HISTORY_STORAGE_KEY];

export const getFilterHistory = (): FilterHistoryItem[] => {
  const raw = safeLocalStorageGetItem(FILTER_HISTORY_STORAGE_KEY);
  if (!raw) return [];
  try {
    const arr = JSON.parse(raw);
    return z.array(FilterHistoryItemSchema).parse(arr);
  } catch {
    return [];
  }
};

export const setFilterHistory = (history: FilterHistoryItem[]) => {
  safeLocalStorageSetItem(FILTER_HISTORY_STORAGE_KEY, JSON.stringify(history));
};
